import DataSource from './DataSource';

export default DataSource;
